"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanField = exports.getDefaultData = exports.getZodSchemaKeys = exports.removeNullUndefined = exports.mongoDBObjectIdSchema = exports.availableAssetTypes = void 0;
const bson_1 = require("bson");
const zod_1 = require("zod");
const MONGODB_ID_REGEX = /^[0-9a-fA-F]{24}$/;
exports.availableAssetTypes = ['powerplant', 'powerplantPortfolio', 'realEstate', 'builderOwnerModel'];
exports.mongoDBObjectIdSchema = zod_1.z.preprocess((val) => {
    if (val === null || val === undefined)
        return val;
    if (typeof val === 'object' && typeof process === 'object' && val instanceof bson_1.ObjectId)
        return val.toHexString();
    if (typeof val === 'object' && val.constructor === Object && '_id' in val) {
        if (typeof val._id === 'object' && typeof process === 'object' && val._id instanceof bson_1.ObjectId)
            return val._id.toHexString();
        return val._id;
    }
    return val;
}, zod_1.z
    .string()
    .regex(MONGODB_ID_REGEX)
    .transform((val) => {
    if (typeof process === 'object') {
        return new bson_1.ObjectId(val);
    }
    return val;
}));
const removeNullUndefined = (obj) => {
    if (obj === null || obj === undefined || NaN) {
        return obj;
    }
    if (typeof obj !== 'object') {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(exports.removeNullUndefined);
    }
    // To avoid converting none plain objects to empty objects
    if (!isPlainObject(obj))
        return obj;
    return clearEmpties(Object.fromEntries(Object.entries(obj)
        .filter(([, value]) => value !== null && value !== undefined && value !== '' && !Number.isNaN(value))
        .map(([key, value]) => [key, (0, exports.removeNullUndefined)(value)])));
};
exports.removeNullUndefined = removeNullUndefined;
const isPlainObject = (value) => value?.constructor === Object;
function clearEmpties(o) {
    for (const k in o) {
        if (!o[k] || typeof o[k] !== 'object' || !isPlainObject(o[k])) {
            continue; // If null or not an object, skip to the next iteration
        }
        // The property is an object
        clearEmpties(o[k]); // <-- Make a recursive call on the nested object
        if (Object.keys(o[k]).length === 0) {
            delete o[k]; // The object had no properties, so delete that property
        }
    }
    return o;
}
const getZodSchemaKeys = (schema, prefix = '') => {
    if (schema instanceof zod_1.z.ZodEffects) {
        return (0, exports.getZodSchemaKeys)(schema._def.schema, prefix);
    }
    if (schema instanceof zod_1.z.ZodObject) {
        return Object.keys(schema.shape).flatMap((key) => {
            if (prefix !== '') {
                return (0, exports.getZodSchemaKeys)(schema.shape[key], prefix + '.' + key);
            }
            return (0, exports.getZodSchemaKeys)(schema.shape[key], key);
        });
    }
    if (schema instanceof zod_1.z.ZodOptional && schema._def.innerType instanceof zod_1.z.ZodObject) {
        return Object.keys(schema._def.innerType.shape).flatMap((key) => {
            if (prefix !== '') {
                return (0, exports.getZodSchemaKeys)(schema._def.innerType.shape[key], prefix + '.' + key);
            }
            return (0, exports.getZodSchemaKeys)(schema._def.innerType.shape[key], key);
        });
    }
    return prefix;
};
exports.getZodSchemaKeys = getZodSchemaKeys;
/**
 * This will generate a default instance from a zod schema, Meaning that it will put `null` as the value of all the Date Fields and `[]` as the value of all the Array Fields
 * @param schema The ZodSchema to generate default data from
 * @returns The default data for the given schema
 */
const getDefaultData = (schema) => {
    if (schema instanceof zod_1.z.ZodDefault) {
        return schema._def.defaultValue();
    }
    if (schema instanceof zod_1.z.ZodArray) {
        return [];
    }
    if (schema instanceof zod_1.z.ZodEffects) {
        return (0, exports.getDefaultData)(schema._def.schema);
    }
    if (schema instanceof zod_1.z.ZodOptional) {
        return (0, exports.getDefaultData)(schema._def.innerType);
    }
    if (schema instanceof zod_1.z.ZodEnum) {
        return undefined;
    }
    if (schema instanceof zod_1.z.ZodString) {
        return undefined;
    }
    if (schema instanceof zod_1.z.ZodDate) {
        return null;
    }
    if (schema instanceof zod_1.z.ZodObject) {
        const result = {};
        for (const key in schema.shape) {
            const defaultValue = (0, exports.getDefaultData)(schema.shape[key]);
            if (defaultValue !== undefined) {
                result[key] = (0, exports.getDefaultData)(schema.shape[key]);
            }
        }
        if (Object.keys(result).length === 0) {
            return undefined;
        }
        return result;
    }
    return undefined;
};
exports.getDefaultData = getDefaultData;
exports.booleanField = zod_1.z.preprocess((v) => {
    if (v === undefined || v === null)
        return false;
    return v;
}, zod_1.z.boolean());
//# sourceMappingURL=utils.js.map